import axios from 'axios';
import { useAuthStore } from '../../store/authStore';

// Create axios instance with base URL from environment variables
// Force relative URLs in development to use Vite proxy
const baseURL = import.meta.env.VITE_API_URL || '/api';


export const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true // This is important for CORS with credentials
});


// Request interceptor for adding auth token and logging
apiClient.interceptors.request.use(
  (config) => {
    
    // Skip auth headers for test endpoints
    if (config.url?.includes('/test')) {
      return config;
    }
    
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor for handling errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.error('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });

    const originalRequest = error.config;

    // Handle token refresh using HTTP-only cookie
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // The refresh token is sent automatically via the HTTP-only cookie
        const response = await apiClient.post('/auth/refresh-token');
        const newToken = response.data.token;

        useAuthStore.setState({ token: newToken });
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return apiClient(originalRequest);
      } catch (refreshError) {
        useAuthStore.getState().logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;